import {
  REMOVE_DOCUMENT_PAGE,
  SET_DOCUMENT_DATA_URL,
  SET_DOCUMENT_FORM,
  UPDATE_DOCUMENT_PAGES_ORDER,
  SET_DOCUMENT_STATUS,
  SET_DOCUMENT_VISITED,
  UPDATE_DOCUMENT_STATUS,
  SET_SCANNED_DOCUMENTS,
  SET_DOCUMENT_COLLECT_BIO_DATA_CONFIRMED,
  SET_DOCUMENT_REJECTED,
  UNSET_DOCUMENT_REJECTED
} from '../actions/rootAction';

import { maxPagesCount } from '../utils';
import { DOC_TYPE_DOCUMENT } from '../../components/helpers/utils';
import { clearPendingSourcePdf } from '../../lib/pendingSourcePdfs';

const documents = (state, action) => {
  switch (action.type) {
    case SET_DOCUMENT_FORM:
      return Object.assign({}, state, {
        forms: new Map(state.forms).set(action.documentId, action.form)
      });
    case SET_DOCUMENT_COLLECT_BIO_DATA_CONFIRMED:
      return Object.assign({}, state, {
        collectBioDataConfirmed: new Set(state.collectBioDataConfirmed).add(
          action.documentId
        )
      });
    case SET_DOCUMENT_STATUS:
      return Object.assign({}, state, {
        documentsStatus: new Map(state.documentsStatus).set(
          action.documentId,
          action.status
        )
      });
    case SET_DOCUMENT_VISITED:
      return Object.assign({}, state, {
        visitedDocuments: new Set(state.visitedDocuments).add(action.documentId)
      });
    case SET_DOCUMENT_REJECTED:
      return Object.assign({}, state, {
        rejectedDocuments: new Set(state.rejectedDocuments).add(
          action.documentId
        )
      });
    case UNSET_DOCUMENT_REJECTED:
      return Object.assign({}, state, {
        rejectedDocuments: new Set(state.rejectedDocuments).delete(
          action.documentId
        )
      });
    case SET_SCANNED_DOCUMENTS:
      return Object.assign({}, state, {
        scannedDocuments: new Map(action.payload)
      });

    case UPDATE_DOCUMENT_STATUS: {
      const status = state.documentsStatus.get(action.documentId);
      return Object.assign({}, state, {
        documentsStatus: new Map(state.documentsStatus).set(action.documentId, {
          ...status,
          ...action.status
        })
      });
    }

    case SET_DOCUMENT_DATA_URL:
    case REMOVE_DOCUMENT_PAGE:
    case UPDATE_DOCUMENT_PAGES_ORDER: {
      const updatedStatus = new Map(state.documentsStatus);
      const documentId = action.documentId;
      const hasSourcePdf =
        state.requestedDocuments.get(documentId).type === DOC_TYPE_DOCUMENT &&
        updatedStatus.has(documentId);
      const scannedDocumentPages = state.scannedDocuments.has(documentId)
        ? state.scannedDocuments.get(documentId)
        : new Map();

      if (hasSourcePdf && scannedDocumentPages.size) {
        //console.log('Remove source PDF');
        updatedStatus.delete(documentId);
        clearPendingSourcePdf(documentId);
      }
      const updatedDocuments = new Map(state.scannedDocuments);
      const updatedErrorSentKeys = new Set(state.errorSentKeys);

      switch (action.type) {
        case SET_DOCUMENT_DATA_URL:
          for (const [pageId, url] of action.preparedPages.entries()) {
            if (scannedDocumentPages.size === maxPagesCount) break;
            scannedDocumentPages.set(pageId, url);
            updatedErrorSentKeys.delete(documentId + pageId);
          }

          updatedDocuments.set(documentId, new Map(scannedDocumentPages));
          break;

        case REMOVE_DOCUMENT_PAGE:
          if (action.pageId instanceof Set) {
            for (let id of action.pageId) {
              scannedDocumentPages.delete(id);
              updatedErrorSentKeys.delete(documentId + id);
            }
          } else {
            scannedDocumentPages.delete(action.pageId);
            updatedErrorSentKeys.delete(documentId + action.pageId);
          }
          updatedDocuments.set(documentId, new Map(scannedDocumentPages));
          if (scannedDocumentPages.size === 0) {
            clearPendingSourcePdf(documentId);
          }
          break;

        case UPDATE_DOCUMENT_PAGES_ORDER:
          {
            const pages = Array.from(scannedDocumentPages);
            pages.splice(
              action.newIndex,
              0,
              pages.splice(action.oldIndex, 1)[0]
            );
            updatedDocuments.set(
              documentId,
              new Map(pages.map(i => [i[0], i[1]]))
            );
          }
          break;
        //no default
      }
      return Object.assign({}, state, {
        scannedDocuments: updatedDocuments,
        documentsStatus: updatedStatus,
        errorSentKeys: updatedErrorSentKeys
      });
    }

    default:
      return state;
  }
};

export default documents;
